import { gql } from '@apollo/client'
import { CORE_SENSOR_FIELDS } from './fragments/sensor'
import { CORE_SETTINGS_FIELDS } from './fragments/settings'
import { CORE_USER_FIELDS } from './fragments/user'
import { CORE_SUBSCRIPTION_FIELDS } from './fragments/subscription'
import { CORE_ADDRESS_FIELDS } from './fragments/address'

export const FETCH_USER = gql`
  ${CORE_USER_FIELDS}
  ${CORE_ADDRESS_FIELDS}
  ${CORE_SETTINGS_FIELDS}
  ${CORE_SENSOR_FIELDS}
  ${CORE_SUBSCRIPTION_FIELDS}
  query currentUser {
    currentUser {
      ...CoreUserFields
      referralUrl
      eligibleForInsuranceCoverage
      address {
        ...CoreAddressFields
      }
      paymentMethod {
        stripeId
        cardType
        last4
        expirationDate
      }
      subscriptions {
        ...CoreSubscriptionFields
      }
      ongoingDietitianSubscription {
        id
      }
      addonLimits {
        description
        limit
        purchasedAmount
        productId
      }
      dexcomConnection {
        status
        lastSyncedAt
      }
      dexcomSteloConnection {
        status
        lastSyncedAt
      }
      primaryGoal {
        title
        kind
        description
      }
      coachChatConversation {
        id
        intercomId
        candidateRead
      }
      mntChatConversation {
        id
        intercomId
        candidateRead
      }
      stressChatConversation {
        id
        intercomId
        candidateRead
      }
      goalMetrics {
        primary
        kind
        lowThresholdValue
        highThresholdValue
        section
        statKey
      }
      uxSensorMode {
        kind
      }
      settings {
        ...CoreSettingsFields
      }
      sensor {
        ...CoreSensorFields
      }
      upsellOffer {
        badge
        benefits {
          title
          description
          icon
        }
        benefitsDescription
        benefitsTitle
        billingProduct
        billingProductName
        billingProductPrice
        cheaperSensors
        cheaperSensorsDescriptionMarkdown
        descriptionMarkdown
        subscriptionId
        title
        upgradeDescription
        upgradeCallToAction
      }
      userProperties {
        videoCallRescheduleFreePassUsed {
          value
        }
        mfpPromotionCardDismissalTimestamp {
          value
        }
        byosVideoCallsUpsell {
          value
        }
        insuranceSurveySkipReason {
          value
        }
      }
      onboardingExperience {
        kind
        participating
        baselineWeight
        desiredWeight
        fourWeekWeight
        dateToReachDesiredWeight
        realisticWeightLoss
        desiredWeightLossAmount
      }
    }
  }
`
